import type { LightboxBenefits } from "~/clientState/hooks/model/lighboxContract";
import { Perk, Plan } from "~/clientState/hooks/model/lighboxContract";
import { BENEFIT_TRACKING } from "~/components/acquisition/Lightbox/LightboxRevamp/config/tracking";

// TODO: After the fe-api implementation, move this hardcoded data to the mock:
// src/mocks/lightboxBenefitsMock.ts
const lightboxBenefitsData: LightboxBenefits = {
  benefits: [
    {
      key: BENEFIT_TRACKING.DISCOUNTS,
      title: "visibility.lightbox.section.one.accordion.one.title",
      description: "visibility.lightbox.section.one.accordion.one.description",
      iconCategory: "Deals",
      icon: "Savings",
      plan: Plan.Prime,
      category: "visibility.lightbox.section.one.title",
    },
    {
      key: BENEFIT_TRACKING.PRIME_3,
      title: "visibility.lightbox.section.one.accordion.five.title",
      description: "visibility.lightbox.section.one.accordion.five.description",
      iconCategory: "Prime",
      icon: "Rewards",
      isPrime3: true,
      plan: Plan.Prime, //TODO: Prime 3.0 hook to see if the benefit is for Prime basic and/or Prime plus - OPRIME-4264
      category: "visibility.lightbox.section.one.title",
    },
    {
      key: BENEFIT_TRACKING.FRIENDS_AND_FAMILY,
      title: "visibility.lightbox.section.one.accordion.two.title",
      description: "visibility.lightbox.section.one.accordion.two.description",
      iconCategory: "Deals",
      icon: "CashHands",
      plan: Plan.PrimePlus,
      category: "visibility.lightbox.section.one.title",
    },
    {
      key: BENEFIT_TRACKING.PROMOCODES,
      title: "visibility.lightbox.section.one.accordion.three.title",
      description:
        "visibility.lightbox.section.one.accordion.three.description",
      iconCategory: "Deals",
      icon: "PercentageDiscount",
      plan: Plan.Prime,
      category: "visibility.lightbox.section.one.title",
    },
    {
      key: BENEFIT_TRACKING.SALES,
      title: "visibility.lightbox.section.one.accordion.four.title",
      description: "visibility.lightbox.section.one.accordion.four.description",
      iconCategory: "Deals",
      icon: "TagDiscount",
      plan: Plan.Prime,
      category: "visibility.lightbox.section.one.title",
    },
    {
      key: BENEFIT_TRACKING.PRICE_FREEZE,
      title: "visibility.lightbox.section.two.accordion.one.title",
      description: "visibility.lightbox.section.two.accordion.one.description",
      iconCategory: "Deals",
      icon: "PriceFreeze",
      plan: Plan.Prime,
      category: "visibility.lightbox.section.two.title",
    },
    {
      key: BENEFIT_TRACKING.FREE_CANCELLATION,
      title: "visibility.lightbox.section.two.accordion.two.title",
      description: "visibility.lightbox.section.two.accordion.two.description",
      iconCategory: "Security",
      icon: "ShieldCheck",
      plan: Plan.PrimePlus,
      category: "visibility.lightbox.section.two.title",
      perk: Perk.FreeCancellation,
      appOnly: true,
      termsAndConditions:
        "visibility.lightbox.section.two.accordion.two.termsAndConditions",
      termsAndConditionsLink:
        "prime.primefreecancellation.termsandconditions.url",
    },
    {
      key: BENEFIT_TRACKING.FREE_CANCELLATION_FREE_TRIAL,
      title: "visibility.lightbox.section.two.accordion.two.freetrial.title",
      description:
        "visibility.lightbox.section.two.accordion.two.freetrial.description",
      iconCategory: "Security",
      icon: "ShieldCheck",
      plan: Plan.PrimePlus,
      category: "visibility.lightbox.section.two.title",
      perk: Perk.FreeCancellationFreeTrial,
      appOnly: true,
      termsAndConditions:
        "visibility.lightbox.section.two.accordion.two.freetrial.termsAndConditions",
      termsAndConditionsLink:
        "prime.primefreecancellation.termsandconditions.url",
    },
    {
      key: BENEFIT_TRACKING.VIP_SUPPORT,
      title: "visibility.lightbox.section.three.accordion.one.title",
      description:
        "visibility.lightbox.section.three.accordion.one.description",
      iconCategory: "User",
      icon: "SupportAgent",
      plan: Plan.Prime,
      category: "visibility.lightbox.section.three.title",
    },
    {
      key: BENEFIT_TRACKING.AIRLINE_REFUNDS,
      title: "visibility.lightbox.section.three.accordion.two.title",
      description:
        "visibility.lightbox.section.three.accordion.two.description",
      iconCategory: "Baggage",
      icon: "Wallet",
      plan: Plan.Prime,
      category: "visibility.lightbox.section.three.title",
    },
  ],
};

export default lightboxBenefitsData;
